// Sample testimonials — replace with verified member reviews.
const testimonials = [
  {
    id: "t1",
    name: "Sample Member",
    rating: 5,
    review:
      "The trainers actually pay attention here. My form improved fast and I look forward to every session. (Sample review)",
  },
  {
    id: "t2",
    name: "Sample Member",
    rating: 5,
    review:
      "Clean equipment, motivating atmosphere, and a schedule that fits around my work hours. (Sample review)",
  },
  {
    id: "t3",
    name: "Sample Member",
    rating: 4,
    review:
      "Firm Fit Factory made consistency easy for me — the community keeps me coming back. (Sample review)",
  },
  {
    id: "t4",
    name: "Sample Member",
    rating: 5,
    review:
      "Personal training here is genuinely one-on-one. My coach adjusts every session to how I'm feeling. (Sample review)",
  },
];

export default testimonials;
